import postAPI from './postAPI.js'

export default async function getAdminTaskInstanceDetails(id) {
    const data = await postAPI('admin/taskinstances/get', { id });
    return data;
}
